import _ from 'lodash';
import {getDefaultPieFormatting} from '@/containers/E4ImpactMBA/charts/pie';
import getValidSubmissions from '@/containers/E4ImpactMBA/helpers/getValidSubmissions';
import {numberOfHighSkillJobsCreatedPerEntrepreneurByGenderTotalCalculation} from '../total-calculations/number-of-high-skill-jobs-created-per-entrepreneur-by-gender-total-calculation';
import {COLORS} from '@/utils/constants';

/**
 * Survey: PROJECT - BASELINE IMPACT
 * Question: How many employees are in managerial positions?
 * 
 * == baseline
 * mgr_women_t0
 * 
 * Survey: PROJECT - FINAL IMPACT
 * Question: How many employees are in managerial positions?
 * 
 * == final
 * mgr_women_t1
 * 
 * @param props 
 * @returns 
 */
export const numberOfHighSkillJobsCreatedPerEntrepreneurByGenderChartCalculation = (props: any) => {
    const {filteredBaseline, filteredFinal} = getValidSubmissions(
        props.baselineSubmissions,
        props.finalSubmissions
    );

    const totalPositions = numberOfHighSkillJobsCreatedPerEntrepreneurByGenderTotalCalculation(props);
    const womenPositions = totalPositions - (_.sumBy(filteredFinal, 'mgr_women_t1') - _.sumBy(filteredBaseline, 'mgr_women_t0'));
    const menPositions = totalPositions - womenPositions;

    const data = [
        {
            name: 'WOMEN Managerial position',
            color: COLORS.e4ImpactOrange,
            y: womenPositions < 0 ? 0 : womenPositions,
        },
        {
            name: 'MEN Managerial position',
            color: COLORS.e4ImpactBlue,
            y: menPositions < 0 ? 0 : menPositions,
        }
    ];

    return getDefaultPieFormatting(
        '',
        data
    ) as Highcharts.Options;
}